<template>
  <Layout
    class="webinar-layout-wrapper"
    :class="{'is-live': webcast.status == 'live', 'hasStreams': hasStreams, 'hasCTA': pageSettings.callToActionEnabled}"
  >
    <!--
    <div class="play-overlay">
      <Button type="text" shape="circle" icon="ios-play"></Button>
    </div>
    -->
    <Navbar :windowSizes="windowSizes" :isSiderControl="true" @siderHandler="collapsedSider" />
    <StatusUpcoming v-if="webcast.status === 'upcoming'" />
    <StatusEnded v-else-if="webcast.status === 'ended' && !webcast.enableVOD" />
    <template v-else>
      <Layout
        class="main-layout"
        :class="{ 'is-mobile-sider': windowSizes.width < 768 }"
        v-if="isReady"
      >
        <WebinarMediaContent />
        <Sider
          class="live-sider"
          v-if="hasWidgets && windowSizes.width > 767"
          :class="{'hasStreams': hasStreams}"
          ref="sider"
          width="360"
          collapsed-width="0"
          hide-trigger
          collapsible
          v-model="isCollapsed"
        >
          <Layout>
            <!-- <Button @click="closeWidget" shape="circle" class="sider-toggle-btn" :class="{'collapsed': isCollapsed}" :icon="siderIcon"></Button> -->
            <widget-container :isCollapsed="isCollapsed"></widget-container>
          </Layout>
        </Sider>
        <div class="mobile-sider" v-else>
          <widget-container :isCollapsed="isCollapsed"></widget-container>
        </div>
      </Layout>
    </template>
  </Layout>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Navbar from "@/components/webinar/Navbar.vue";
import WebinarMediaContent from "@/components/webinar/WebinarMediaContent.vue";
import WidgetContainer from "@/components/widgets2/NewWidgetContainer.vue";
import StatusUpcoming from "@/components/webinar/StatusUpcoming.vue";
import StatusEnded from "@/components/webinar/StatusEnded.vue";

export default {
  name: "webinar",
  components: {
    WidgetContainer,
    WebinarMediaContent,
    Navbar,
    StatusUpcoming,
    StatusEnded
  },
  data() {
    return {
      attId: "",
      isCollapsed: false,
      isReady: false,
      sidebarContent: null,
      windowSizes: {
        width: 1280,
        height: 720
      }
    };
  },
  computed: {
    ...mapGetters("current", {
      current: "get"
    }),
    webcast() {
      return this.current("webcast");
    },
    ...mapGetters("stream", {
      streamsInStore: "find",
      getStreamInStore: "get"
    }),
    ...mapGetters("registrations", {
      registration: "getCopy"
    }),
    ...mapGetters("page-settings", {
      pageSettings: "getCopy"
    }),
    ...mapGetters("widgets", {
      findWidgetsInStore: "find"
    }),
    widgets() {
      return this.findWidgetsInStore().data;
    },
    hasWidgets() {
      if (this.widgets.length >= 1) {
        return true;
      } else {
        return false;
      }
    },
    siderIcon() {
      if (this.isCollapsed) {
        return "ios-arrow-back";
      } else {
        return "ios-arrow-forward";
      }
    },
    hasStreams() {
      if (this.webcast.status != "live") return false;
      else if (this.streamsInStore().data.length > 1) return true;
      else return false;
    }
  },
  methods: {
    ...mapActions("registrations", {
      initUserAction: "initUser"
    }),
    ...mapActions("widgets", {
      findWidgetsAction: "find"
    }),

    collapsedSider() {
      this.$refs.sider.toggleCollapse();
    },

    openWidget(index) {
      let widget = this.widgets[index];

      if (_.isEqual(this.currentWidget, widget) || this.isCollapsed) {
        this.collapsedSider();
      }
      this.currentWidget = widget;
      // console.log(this.currentWidget);
    },

    closeWidget() {
      this.collapsedSider();
      // this.currentWidget = undefined
    },

    handleResize() {
      this.windowSizes = {
        width: window.innerWidth,
        height: window.innerHeight
      };
    }
  },
  created() {
    this.$store.commit("widgets/clearAll");
    this.findWidgetsAction({ query: { webcastId: this.webcast._id } }).then(
      res => {
        if (this.hasWidgets) {
          this.$data.isCollapsed = false;
        } else {
          this.$data.isCollapsed = true;
        }

        this.$set(this.$data, "isReady", true);
        setTimeout(() => {
          this.handleResize();
          window.addEventListener("resize", this.handleResize);
        }, 500);

        // console.log(this.$data.currentWidget);
      }
    );
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style lang="less">
.webinar-status {
  height: 100vh;
  padding: 64px 16px 16px 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #272727;
  line-height: 1.2;
  .status-box {
    width: 100%;
    max-width: 720px;
    padding: 48px 16px;
    background: #fff;
    text-align: center;
    .timer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 48px;
      &--item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 12px;
        &__desc {
          font-weight: 500;
          font-size: 14px;
          color: #999999;
        }
        &__time {
          font-weight: 500;
          font-size: 56px;
          color: #000000;
          line-height: 1;
          @media (max-width: 575px) {
            font-size: 32px;
          }
        }
      }
    }
    h2 {
      font-weight: 600;
      font-size: 32px;
      margin: 0;
      @media (max-width: 575px) {
        font-size: 24px;
      }
    }
    h3 {
      font-weight: 500;
      font-size: 18px;
      margin: 8px 0 0 0;
      @media (max-width: 575px) {
        font-size: 16px;
      }
    }
    p {
      font-weight: 500;
      font-size: 12px;
      color: #999999;
      margin: 8px 0 0 0;
    }
  }
  &.is-ended {
    .status-box {
      padding: 96px 16px;
    }
  }
}
</style>

<style lang="less" scopped>
.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
  vertical-align: middle;
  font-size: 22px;
}

.sider-toggle-btn {
  position: absolute;
  right: 485px;
  width: 36px !important;
  height: 36px !important;
  top: 70px;
  z-index: 99999;
  &.collapsed {
    right: 10px;
  }
}

.main-layout {
  &.is-mobile-sider {
    @media (max-width: 575px) {
      flex-direction: column;
      padding-top: 64px;
      height: 100vh;
      .webinar-media-content-wrapper,
      .mobile-sider {
        width: 100%;
      }
      .mobile-sider {
        flex-grow: 1;
        overflow: auto;
      }
    }
  }
}

.live-page {
  height: 100vh;
}

.live-sider {
  border-left: 1px solid #e9eaec;
  padding-top: 64px;
  @media (min-width: 768px) {
    max-height: 100vh;
    overflow: auto;
  }
}

@media screen and (max-width: 992px) {
  .live-page {
    .live-content {
      width: 100%;
      z-index: 1000;
      @media screen and (min-width: 992px) {
        transform: translateY(-50%);
        top: 50%;
        position: relative;
        width: 80%;
        margin: auto;
      }
    }
    .live-sider {
      border-left: none;
    }

    .main-layout {
      //flex-wrap: wrap;
    }

    .ivu-layout-sider {
      width: 100% !important;
      max-width: inherit !important;
      flex-basis: 100% !important;
      flex: inherit !important;
      padding-top: 56.25%;
      position: fixed;
      height: 100vh;
    }

    .ivu-layout-content {
      //height: 45vh;

      overflow: visible;
      overflow-x: hidden;
    }

    .ivu-layout-sider {
      //height: ~"calc(100vh - (45vh + 30px))";
      min-width: inherit !important;
    }

    .ivu-layout {
      padding-bottom: 0 !important;
      height: 100%;
    }
  }
  .hasStreams .ivu-layout-sider {
    padding-top: calc(56.25% + 48px);
  }

  .hasCTA .ivu-layout-sider {
    padding-top: calc(56.25% + 48px);
  }
  .poweredby_logo {
    background-image: url(/img/powered_by_logo.png);
    background-color: transparent;
    width: 96px;
    height: 66px;
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 0.2;
    left: 32px;
    position: absolute;
    bottom: 0px;
  }
}
</style>
